import { useEffect, useState } from "react";
import { Form, Tabs } from "antd";
import ViewPPTData from "./ViewPPTData";
import SearchModal from "./SearchModal";
import { ResetFileUpload } from "../../redux/exchange/actionCreator";
import { useDispatch } from "react-redux";
const ProductDetails = ({
    data,
    searchList,
    deleteTabAtIndex,
    isVisible,
    selectedOldPhone,
    comparissionTableData,
    setAutoStop,
    formData,
    setFormData,
    form,
    setLoader,
    setAutoResume,
    modelSubmit,
    setModelSubmit
}) => {

    const dispatch = useDispatch()
    const [activeKey, setActiveKey] = useState("1");
    const [items, setItems] = useState([]);
    const [isSearchVisble, setIsSearchVisble] = useState(false);
    const activeTab = items.find(item => item.key === activeKey);
    const [uploadedImages, setUploadedImages] = useState([]);
    const activeColor = activeTab?.color || 'transparent';
    const [form2] = Form.useForm();

    useEffect(() => {
        if (data && data.length > 0) {
            const newTabs = data.map((item, index) => {
                const newKey = String(index + 1);
                return {
                    label: item?.data?.check_document?.rule_name,
                    key: newKey,
                    children: <ViewPPTData
                        aboutInfoPPTDetailsData={item}
                        selectedOldPhone={selectedOldPhone}
                        isVisible={isVisible}
                        comparissionTableData={comparissionTableData}
                        setAutoStop={setAutoStop}
                        formData={formData}
                        setFormData={setFormData}
                        form={form}
                        setLoader={setLoader}
                        setAutoResume={setAutoResume}
                        modelSubmit={modelSubmit}
                        setModelSubmit={setModelSubmit}
                        setUploadedImages={setUploadedImages}
                        uploadedImages={uploadedImages}
                        form2={form2}
                    />,
                    // color: "green"
                };
            });
            setItems(newTabs);
            setActiveKey(String(newTabs.length))
        }
    }, [data]);

    const resetData = () => {
        form2.resetFields();
        dispatch(ResetFileUpload())
        setUploadedImages([])
    }

    const add = () => {
        setIsSearchVisble(true)
        resetData()
    };

    const onEdit = (targetKey, action) => {
        if (action === "add") {
            add();
        } else {
            deleteTabAtIndex(targetKey - 1);
        }
    };

    const onTabChange = (key) => {
        setActiveKey(key);
        resetData()
    };

    return (
        <>
            <Tabs
                type="editable-card"
                size="small"
                activeKey={activeKey}
                onChange={onTabChange}
                onEdit={onEdit}
                items={items}
                className="custom-tabs"
            />
            <SearchModal data={searchList} isSearchVisble={isSearchVisble} setIsSearchVisble={setIsSearchVisble} />

            <style>{`
                .custom-tabs {
                    background: ${activeColor};
                    padding: 24px;
                    border-radius: 8px;
                }

                @media (max-width: 768px) {
                    .custom-tabs {
                        padding: 0;
                    }
                }
            `}</style>
        </>
    );
};
export default ProductDetails;
